module.exports = "/images/vendor/desiigner-svg/svg/places/statue-of-liberty.svg?dd2b668c2da6ec4ea993076ceb2af4fc";